import { render, staticRenderFns } from "./serviceRatio.vue?vue&type=template&id=006fbef3&scoped=true&"
import script from "./serviceRatio.vue?vue&type=script&lang=js&"
export * from "./serviceRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006fbef3",
  null
  
)

export default component.exports